module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    attrs: {
      "label": _vm.label,
      "error-messages": _vm.emailValidationError,
      "rules": _vm.emailRules,
      "value": _vm.value,
      "autocomplete": "off",
      "hide-details": _vm.hideDetails,
      "prepend-icon": _vm.icon
    },
    on: {
      "input": _vm.emailInput,
      "change": _vm.validateEmail
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function() {
        return [(_vm.status == 'Checking') ? _c('v-progress-circular', {
          attrs: {
            "size": "20",
            "width": "2",
            "color": "info",
            "indeterminate": ""
          }
        }) : _vm._e(), _vm._v(" "), (_vm.status == '') ? _c('v-icon', {
          attrs: {
            "color": "green"
          }
        }, [_vm._v("check_circle")]) : _vm._e()]
      },
      proxy: true
    }])
  }), _vm._v(" "), (_vm.confirmationVisible) ? _c('v-text-field', {
    ref: "confirmation",
    attrs: {
      "label": "Confirm Email",
      "autocomplete": "off",
      "hide-details": _vm.hideDetails,
      "prepend-icon": _vm.confirmationIcon
    },
    model: {
      value: (_vm.confirmation),
      callback: function($$v) {
        _vm.confirmation = $$v
      },
      expression: "confirmation"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05a1b5a4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/EmailBox.vue
// module id = 2433
// module chunks = 1